import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';
import BasicLink from 'app/components/Links/BasicLink.styled';

const { widthSmall, widthMedium, widthLarge } = breakpoints;
const S = {};

S.Footer = styled.footer`
  label: Footer;

  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: auto auto 0;
  padding: 1.5rem 1.25rem 2rem;

  @media (${widthSmall}) {
    padding: 1.5rem 1.25rem 2.5rem;
  }

  @media (${widthMedium}) {
    padding: 1.5rem 1.25rem 2rem;
  }
`;

S.FooterLinkDivider = styled.span`
  label: FooterLinkDivider;

  &:after {
    display: none;
    content: '|';
    padding: 0 1rem;
    color: var(--colors-silver);
  }

  @media (${widthSmall}) {
    &:after {
      display: block;
    }

    &:nth-of-type(3):after {
      display: none;
    }
  }

  @media (${widthLarge}) {
    &:after {
      display: block;
    }

    &:nth-of-type(3):after {
      display: block;
    }
  }
`;

S.FooterLink = styled(BasicLink)`
  label: FooterLink;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }

  &.do-not-sell-text {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    .do-not-sell-icon {
      height: 0.875rem;
    }
  }

  @media (${widthSmall}) {
    &:not(:last-child) {
      margin-bottom: 0.75rem;
    }
  }

  @media (${widthMedium}) {
    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
`;

S.FooterTopRow = styled.div`
  label: FooterTopRow;

  text-align: center;
  margin-bottom: 2rem;

  @media (${widthSmall}) {
    margin-bottom: 1.5rem;
  }

  @media (${widthMedium}) {
    margin-bottom: 2.3rem;
  }
`;

S.LinksWrapper = styled.div`
  label: LinksWrapper;

  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;

  @media (${widthSmall}) {
    flex-direction: row;
    justify-content: center;
    align-items: baseline;
  }
`;

S.FlexDivider = styled.div`
  label: FlexDivider;

  display: none;

  @media (${widthSmall}) {
    display: block;
    height: 0;
    flex-basis: 100%;
  }

  @media (${widthLarge}) {
    display: none;
  }
`;

S.FooterBottomRow = styled.div`
  label: FooterBottomRow;

  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media (${widthSmall}) {
    padding: 0 2.5rem;
  }

  @media (${widthMedium}) {
    flex-direction: row;
    justify-content: space-between;
    max-width: 77.5rem;
  }
`;

S.Footer.Copyright = styled.p`
  label: Copyright;

  margin-bottom: 2rem;

  @media (${widthMedium}) {
    margin-bottom: 0;
  }
`;
export default S;
